import Vue from 'vue'
export default {
  namespaced: true,
  state: {
    printData: {},
    printType: '15',

  },
  mutations: {
    setPrintType(state, val) {
      state.printType = val
    },
    setPrintData(state, val) {
      state.printData = val
    },
  },
  actions: {

  },
  getters: {

  },
}
